import { render, staticRenderFns } from "./InfoComponent.vue?vue&type=template&id=a04a83aa&scoped=true&"
import script from "./InfoComponent.vue?vue&type=script&lang=js&"
export * from "./InfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./InfoComponent.vue?vue&type=style&index=0&id=a04a83aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04a83aa",
  null
  
)

export default component.exports